<template>
    <div v-if="categoryList != null" class="main-panel">
        <table width=100% cellpadding=0 cellspacing=0>
            <tr class="itemheader">
                <td style="width:100%; vertical-align:top">
                    <div class="inner-panel">
                        <div class="object-titlebox">
                            <div class="object-titlebox-left" v-t="'message.menu_manual'"></div>
                            <div class="object-titlebox-right" style="padding-right:20px" v-t="'message.item_version'"></div>
                        </div>
                        <table style="width:100%">
                            <template v-for="category in categoryList">
                                <tr v-for="manual in category.manual" class="manual-record" style="display:table-row">
                                    <td class="manual-name" style="width:80%;display: table-cell">
                                        <a :href="getManualURL(manual.fileName)" :download="manual.name" target="_blank">{{ manual.name }}</a>
                                    </td>
                                    <td class="manual-name" style="width:20%;display: table-cell;padding-right:20px;text-align: right">
                                        {{ manual.version }}
                                    </td>
                                </tr>
                            </template>
                        </table>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

export default {
    components: {

    },

    props: {
        appData: {
            type: Object,
            required: true
        }
    },

    data () {
        return {
            // 現在カテゴリーはないが、Manual.vueがカテゴリーに対応しているためこのコンポーネントでも同様の構成に対応する
            categoryList: null,
        }
    },

    computed: {

    },

    watch: {
        '$i18n.locale'(newVal) {
            this.setCategoryList();
        },
    },

    created: function() {
        this.setCategoryList();
    },

    methods: {
        setCategoryList() {
            this.categoryList = [];
            if (this.$i18n.locale === 'ja') {
                let self = this;
                window['$manualList'] = function(data){
                    self.categoryList = data;
                };
                var script = document.createElement('script');
                script.src = "https://www.science-arts.com/downloads/buddycom/manual/kbx/manuallist.js" + "?ts=" + new Date().getTime();;
                document.body.appendChild(script);
            }
        },

        getManualURL(fileName) {
            return "https://www.science-arts.com/downloads/buddycom/manual/kbx/" + fileName;
        },
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inner-panel {
    overflow-x: hidden;
    overflow-y: auto;
}

a, a:hover, a:visited, a:link, a:active {
    color: #333B48;
    text-decoration: none;
}

td a {
    display: block;
}

.manual-record {
    color: #848991;
    border-bottom:1px #eee solid;
    display: block;
}

.manual-record:hover {
    background-color: #ecf1fa;
}

.manual-name {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 14px;
    vertical-align: middle;
}

</style>
